<mat-tel-input
  [id]="id"
  [name]="name"
  [required]="required"
  [disabled]="disabled"
  [preferredCountries]="preferredCountries"
  [(ngModel)]="phoneValue"
  format="national"
  describedBy="phoneInput"
  (ngModelChange)="onTextInputChange($event, phone)"
  #phone
></mat-tel-input>
